import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class DashboardSummaryComponent implements OnInit {

  @Input() data: any = {}

  constructor() { }

  ngOnInit(): void {
  }

}
